import React from 'react';
import { observer } from 'mobx-react';
import { CampaignUserStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers';
import { SurveyContent } from '@gamiphy/loyalty-station-desktop/components/survey/content';
import { Pages, Tabs, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { PopulatedCampaignUserDto } from '@coretava/api/ecommerce-service';

const Survey: React.FC<{ campaignUser: PopulatedCampaignUserDto }> = ({ campaignUser }) => (
  <SurveyContent
    appSurvey={CampaignUserStore.appSurvey}
    onDone={() => {
      UiStore.setPage(Pages.home);
      UiStore.setTab(Tabs.Campaign, campaignUser.campaign.id);
    }}
  />
);

export default observer(Survey);
